package com.cross.sync.landing.pages.ru

import androidx.compose.runtime.Composable
import com.cross.sync.landing.pages.LandingPage
import com.cross.sync.landing.pages.RussianCopy
import com.varabyte.kobweb.core.Page

@Page
@Composable
fun RuPage() {
    LandingPage(RussianCopy)
}
